
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppMailTemplateEditor from "@/components/mail/MailTemplateEditor.vue";
import { ReminderEmailTemplate } from "@/models/reminder-email-template";
import { ReminderTemplate } from "@/models/reminder-template";
import { ReminderService } from "@/services/reminder-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppReminderEmailTemplatePropSelect from "./ReminderEmailTemplatePropSelect.vue";

export default Vue.extend({
	data() {
		return {
			selectedLang: "nl-be",
			reminderTemplates: [] as ReminderTemplate[],
			contentAsText: "",
			cursorPosition: 0,
			selectedText: "",
		};
	},
	props: {
		value: {
			type: Object as () => ReminderEmailTemplate,
			required: true
		}
	},
	computed: {
		selectedSubject(): String {
			if (!this.value.Subject.Translations)
				return "";

			return this.value.Subject.Translations[this.selectedLang]
				? this.value.Subject.Translations[this.selectedLang]
				: this.value.Subject.Fallback;
		},
		reminderTemplateItems(): ISelectItem<number>[] {
			return this.reminderTemplates.map(r => {
				return {
					value: r.ReminderID,
					text: r.getName()
				};
			});
		},
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler() {
				this.recomputeSelectedText();
			}
		}
	},
	methods: {
		updateLanguage() {
			this.recomputeSelectedText();
		},
		async addProp(prop: string) {
			(this.$refs.editor as any).insertText(prop);
		},
		addLink(url: string, text: string) {
			(this.$refs.editor as any).insertLink(text, url);
		},
		onSubjectUpdate(value: string) {
			this.value.Subject.Translations[this.selectedLang] = value;
		},
		onContentUpdate(value: string) {
			this.value.Content.Translations[this.selectedLang] = value;
			this.recomputeSelectedText();
		},
		recomputeSelectedText() {
			let val = this.value.Content.Translations[this.selectedLang];
			if (val == null) {
				this.selectedText = "";
			} else {
				this.selectedText = val;
			}
		}
	},
	async mounted() {
		this.reminderTemplates = await ReminderService.getReminderTemplates();
	},
	components: {
		AppCustomLangSelect,
		AppReminderEmailTemplatePropSelect,
		AppMailTemplateEditor
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
